import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import MangeDashboard from "./Dashboard/ManageDashboard";
import { toast } from "react-toastify";

export default function Callback() {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState({});
  useEffect(() => {
    let result = searchParams.get("result");
    if (result) {
      try {
        setMessage(JSON.parse(atob(result)));
      } catch (e) {}
    }
  }, [searchParams]);

  useEffect(() => {
    if (
      Object.keys(message).length > 0 &&
      Object.keys(message).includes("is_success")
    ) {
      if (message.is_success) {
        toast.success(message?.message);
      } else {
        toast.error(message?.message);
      }
    }
  }, [message]);

  return (
    <MangeDashboard>
      <div className="container-for-payment-callback">
        {Object.keys(message).length > 0 &&
        Object.keys(message).includes("is_success") ? (
          <div className="payment-result-info">
            {message.is_success ? (
              <img src={"/images/correct.png"} />
            ) : (
              <img src={"/images/remove.png"} />
            )}
            <div
              className={
                message.is_success
                  ? "message-payment-success"
                  : "message-payment-error"
              }
            >
              {message?.message}
            </div>
            <div className="payment-link-wallet">
              <Link className="btn-submit" to={"/kifpool"}>
                بازگشت به کیف پول
              </Link>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </MangeDashboard>
  );
}
